import { useTerminalsState } from "@/States/Terminals";
import { getInfrastructureUrl } from "@/Utils/getInfrastructureUrl";
import { trpc } from "@/Utils/trpc";

import { useParams } from "react-router-dom";

import { useConfig } from "./useConfig";

export const useSlackNotifications = () => {
  const { terminalId: urlTerminalId } = useParams();
  const { currentTerminal } = useTerminalsState();
  const { isRealEstate } = useConfig();

  const terminalName = currentTerminal?.name ?? "";
  const terminalId = urlTerminalId ?? currentTerminal?.id;

  const sendNewCustomerNotificationMutation =
    trpc.notifications.sendNewCustomerSlackNotification.useMutation();
  const sendNewAccessParentSlackNotificationMutation =
    trpc.notifications.sendNewAccessParentSlackNotification.useMutation();
  const sendNewContainerNotificationMutation =
    trpc.notifications.sendNewContainerSlackNotification.useMutation();

  function createUrlForCustomerPage(path: string) {
    const baseUrl = window.location.origin;
    if (isRealEstate && !terminalId) {
      throw new Error("Failed to create url. Terminal id is undefined.");
    }

    const terminalFiltering = isRealEstate ? `?terminal-id=${terminalId}` : "";
    const url = `${baseUrl}${path}${terminalFiltering}`;
    return url;
  }

  function сreateUrlForInfrastructurePage(pageRoute: string) {
    const baseUrl = window.location.origin;
    if (isRealEstate && !terminalId) {
      throw new Error("Failed to create url. Terminal id is undefined.");
    }

    const terminalFiltering = isRealEstate ? `?terminal-id=${terminalId}` : "";
    const url = `${baseUrl}${pageRoute}${terminalFiltering}`;

    return url;
  }

  const sendNewCustomerSlackNotification = async (
    customerName: string,
    customerId: string,
  ) => {
    const manageCustomerUrl = createUrlForCustomerPage(
      `/customer/manage/${customerId}`,
    );

    await sendNewCustomerNotificationMutation.mutate({
      customerName,
      terminalName,
      manageCustomerUrl,
    });
  };

  const sendNewAccessParentSlackNotification = async (
    accessParentName: string,
    accessParentId: string,
  ) => {
    const pageRoute = getInfrastructureUrl({ terminalId, accessParentId });
    const manageAccessParentUrl = сreateUrlForInfrastructurePage(pageRoute);

    await sendNewAccessParentSlackNotificationMutation.mutate({
      accessParentName,
      terminalName,
      manageAccessParentUrl,
    });
  };

  const sendNewContainerSlackNotification = async (
    containerName: string,
    accessParentId: string,
    containerId: string,
  ) => {
    const pageRoute = getInfrastructureUrl({
      terminalId,
      accessParentId,
      containerId,
    });
    const manageContainerUrl = сreateUrlForInfrastructurePage(pageRoute);

    await sendNewContainerNotificationMutation.mutate({
      containerName,
      terminalName,
      manageContainerUrl,
    });
  };

  return {
    sendNewCustomerSlackNotification,
    sendNewAccessParentSlackNotification,
    sendNewContainerSlackNotification,
  };
};
